export const SET_COMPANY_INVOICES_FOR_CURRENT_FILTER = 'SET_COMPANY_INVOICES_FOR_CURRENT_FILTER'
export const SET_TOTAL_NO_COMPANY_INVOICES_FOR_CURRENT_FILTER = 'SET_TOTAL_NO_COMPANY_INVOICES_FOR_CURRENT_FILTER'
export const SET_COMPANY_INVOICES_CURRENT_PAGE_NUMBER = 'SET_COMPANY_INVOICES_CURRENT_PAGE_NUMBER'
export const SET_COMPANY_INVOICES_PAGE_SIZE = 'SET_COMPANY_INVOICES_PAGE_SIZE'
export const SET_COMPANY_INVOICES_ORDER_BY = 'SET_COMPANY_INVOICES_ORDER_BY'
export const SET_COMPANY_INVOICES_ORDER_DIRECTION = 'SET_COMPANY_INVOICES_ORDER_DIRECTION'
export const SET_COMPANY_INVOICES_FILTER_INVOICE_NUMBER = 'SET_COMPANY_INVOICES_FILTER_INVOICE_NUMBER'
export const SET_COMPANY_INVOICES_FILTER_INVOICE_DATE = 'SET_COMPANY_INVOICES_FILTER_INVOICE_DATE'
export const SET_COMPANY_INVOICES_FILTER_INVOICE_MONTH = 'SET_COMPANY_INVOICES_FILTER_INVOICE_MONTH'
export const SET_COMPANY_INVOICES_FILTER_INVOICE_YEAR = 'SET_COMPANY_INVOICES_FILTER_INVOICE_YEAR'

export default {
  SET_COMPANY_INVOICES_FOR_CURRENT_FILTER,
  SET_TOTAL_NO_COMPANY_INVOICES_FOR_CURRENT_FILTER,
  SET_COMPANY_INVOICES_CURRENT_PAGE_NUMBER,
  SET_COMPANY_INVOICES_PAGE_SIZE,
  SET_COMPANY_INVOICES_ORDER_BY,
  SET_COMPANY_INVOICES_ORDER_DIRECTION,
  SET_COMPANY_INVOICES_FILTER_INVOICE_NUMBER,
  SET_COMPANY_INVOICES_FILTER_INVOICE_DATE,
  SET_COMPANY_INVOICES_FILTER_INVOICE_MONTH,
  SET_COMPANY_INVOICES_FILTER_INVOICE_YEAR
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/mutation-types.js